// extracted by mini-css-extract-plugin
export default {"inlineTicket":"NotEnoughTickets_inlineTicket__Jkjhe","descriptionText":"NotEnoughTickets_descriptionText__clNPn"};